import entitiesReducer from "../lib/entitiesReducer";
import * as actions from "./actions";
import * as pagesTranslationsActions from "../pageTranslations/actions";
import { Record, Map, fromJS } from "immutable";
import { isApiCall } from "../app/schema";

import GalleryItems from "./galleryItems";

const feature = "galleryItems";

const InitialState = Record({
  galleryItems: new GalleryItems()
});

const START = "_START";
const SUCCESS = "_SUCCESS";
const ERROR = "_ERROR";

const initialState = new InitialState();

function revive() {
  return initialState.merge({});
}

export default function GalleryItemsReducer(state = initialState, action) {
  if (!(state instanceof InitialState)) return revive(state);

  if (isApiCall(action.type)) {
    if (
      action.payload &&
      action.payload.entities &&
      action.payload.entities.galleryItems
    ) {
      state = state.updateIn(["galleryItems", "entities"], map =>
        map.mergeDeep(action.payload.entities.galleryItems)
      );
    }
  }

  switch (action.type) {
    case actions.PATCH_GALLERY_ITEM + START: {
      return state.setIn(["galleryItems", "loading"], true);
    }
    case actions.PATCH_GALLERY_ITEM + SUCCESS: {
      return state.setIn(["galleryItems", "loading"], false);
    }
    case actions.PATCH_GALLERY_ITEM + ERROR: {
      return state.setIn(["galleryItems", "loading"], false);
    }

    case actions.DELETE_GALLERY_ITEM + START: {
      return state.deleteIn(["galleryItems", "entities", action.payload.uid]);
    }

    case actions.SET_IS_EDIT_GALLERY_ITEM_MODAL_VISIBLE: {
      return state.setIn(
        ["galleryItems", "isEditModalVisible"],
        action.payload.isVisible
      );
    }

    case actions.SET_IS_REMOVE_GALLERY_ITEM_MODAL_VISIBLE: {
      return state.setIn(
        ["galleryItems", "isRemoveModalVisible"],
        action.payload.isVisible
      );
    }

    case pagesTranslationsActions.GET_PAGES_TRANSLATION + START: {
      return state.setIn(["galleryItems", "loading"], true);
    }
    case pagesTranslationsActions.GET_PAGES_TRANSLATION + SUCCESS: {
      let galleryItems = new Map();
      for (let locale in action.payload.entities.pageTranslations[
        action.payload.result
      ].pageTranslations) {
        for (let section in action.payload.entities.pageTranslations[
          action.payload.result
        ].pageTranslations[locale].sections) {
          for (let sectionItem in action.payload.entities.pageTranslations[
            action.payload.result
          ].pageTranslations[locale].sections[section].galleries) {
            let gallery =
              action.payload.entities.pageTranslations[action.payload.result]
                .pageTranslations[locale].sections[section].galleries[
                sectionItem
              ];
            gallery.items.map(function(galleryItem, index) {
              galleryItems = galleryItems.set(
                galleryItem.uid,
                fromJS(galleryItem)
              );
            });
          }
        }
      }
      state = state.setIn(["galleryItems", "entities"], galleryItems);
      return state.setIn(["galleryItems", "loading"], false);
    }
    case pagesTranslationsActions.GET_PAGES_TRANSLATION + ERROR: {
      return state.setIn(["galleryItems", "loading"], false);
    }

    case pagesTranslationsActions.GET_PAGES_TRANSLATION_BY_UID_START: {
      return state.setIn(["galleryItems", "loading"], true);
    }
    case pagesTranslationsActions.GET_PAGES_TRANSLATION_BY_UID_SUCCESS: {
      let galleryItems = new Map();
      for (let locale in action.payload.entities.pageTranslations[
        action.payload.result
      ].pageTranslations) {
        for (let section in action.payload.entities.pageTranslations[
          action.payload.result
        ].pageTranslations[locale].sections) {
          for (let sectionItem in action.payload.entities.pageTranslations[
            action.payload.result
          ].pageTranslations[locale].sections[section].galleries) {
            let gallery =
              action.payload.entities.pageTranslations[action.payload.result]
                .pageTranslations[locale].sections[section].galleries[
                sectionItem
              ];
            gallery.items.map(function(galleryItem, index) {
              galleryItems = galleryItems.set(
                galleryItem.uid,
                fromJS(galleryItem)
              );
            });
          }
        }
      }
      state = state.setIn(["galleryItems", "entities"], galleryItems);
      return state.setIn(["galleryItems", "loading"], false);
    }
    case pagesTranslationsActions.GET_PAGES_TRANSLATION_BY_UID_ERROR: {
      return state.setIn(["galleryItems", "loading"], false);
    }
  }

  return entitiesReducer(state, feature, action);
}



// WEBPACK FOOTER //
// ./src/common/galleryItems/reducer.js